import React, { Component } from "react";
export default class LanguageNamingSection extends Component {
  render() {
    var {
      picture_name_1,
      picture_status_1,
      picture_name_2,
      picture_status_2,
      picture_name_3,
      picture_status_3,
      picture_name_4,
      picture_status_4,
      picture_name_5,
      picture_status_5,
      picture_name_6,
      picture_status_6,
      picture_name_7,
      picture_status_7,
      picture_name_8,
      picture_status_8,
      written_picture_score,
    } = this.props.data;
    return (
      <div className="row p-0 border border-dark language_naming_section">
        <div className="col-lg-12 p-3">
          <div className="fs-19 pl-4">
            <br />
            <div className="row" style={{ fontSize: 15 }}>
              <div className="col-lg-6 d-flex">
                <div className="flex-wrap picture-div d-flex align-items-center">
                  <p
                    style={{
                      fontSize: 17,
                      position: "relative",
                      top: -50,
                    }}
                  >
                    1)
                  </p>
                  <img
                    className="form-picture"
                    src={"./assets/images/ecas-form/scorpion.png"}
                    alt="scorpion"
                    style={{ width: 190 }}
                  />
                  <div style={{ marginLeft: 7 }}>
                    <input
                      style={{ width: 180 }}
                      name="picture_name_1"
                      value={picture_name_1}
                      type="text"
                      className="ecas-input-field"
                    />
                  </div>
                </div>
                <br />
              </div>
              <div className="col-lg-6 d-flex align-items-baseline">
                <div className="flex-wrap picture-div d-flex align-items-center">
                  <p
                    style={{
                      fontSize: 17,
                      position: "relative",
                      top: -50,
                    }}
                  >
                    2)
                  </p>
                  <img
                    className="form-picture"
                    src={"./assets/images/ecas-form/coller.png"}
                    alt="scorpion"
                    style={{ width: 190 }}
                  />
                  <div style={{ marginLeft: 7 }}>
                    <input
                      style={{ width: 180 }}
                      name="picture_name_2"
                      type="text"
                      className="ecas-input-field"
                      value={picture_name_2}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 d-flex align-items-baseline">
                <div className="flex-wrap picture-div d-flex align-items-center">
                  <p
                    style={{
                      fontSize: 17,
                      position: "relative",
                      top: -50,
                    }}
                  >
                    3)
                  </p>
                  <img
                    className="form-picture"
                    src={"./assets/images/ecas-form/helicopter.png"}
                    alt="scorpion"
                    style={{ width: 190 }}
                  />
                  <div style={{ marginLeft: 7 }}>
                    <input
                      style={{ width: 180 }}
                      name="picture_name_3"
                      type="text"
                      className="ecas-input-field"
                      value={picture_name_3}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 d-flex align-items-baseline">
                <div className="flex-wrap picture-div d-flex align-items-center">
                  <p
                    style={{
                      fontSize: 17,
                      position: "relative",
                      top: -50,
                    }}
                  >
                    4)
                  </p>
                  <img
                    className="form-picture"
                    src={"./assets/images/ecas-form/fox.png"}
                    alt="scorpion"
                    style={{ width: 190 }}
                  />
                  <div style={{ marginLeft: 7 }}>
                    <input
                      style={{ width: 180 }}
                      name="picture_name_4"
                      type="text"
                      className="ecas-input-field"
                      value={picture_name_4}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 d-flex align-items-baseline">
                <div className="flex-wrap picture-div d-flex align-items-center">
                  <p
                    style={{
                      fontSize: 17,
                      position: "relative",
                      top: -50,
                    }}
                  >
                    5)
                  </p>
                  <img
                    className="form-picture"
                    src={"./assets/images/ecas-form/rod.png"}
                    alt="scorpion"
                    style={{ width: 190 }}
                  />
                  <div style={{ marginLeft: 7 }}>
                    <input
                      style={{ width: 180 }}
                      name="picture_name_5"
                      type="text"
                      className="ecas-input-field"
                      value={picture_name_5}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 d-flex align-items-baseline">
                <div className="flex-wrap picture-div d-flex align-items-center">
                  <p
                    style={{
                      fontSize: 17,
                      position: "relative",
                      top: -50,
                    }}
                  >
                    6)
                  </p>
                  <img
                    className="form-picture"
                    src={"./assets/images/ecas-form/rabbit.png"}
                    alt="scorpion"
                    style={{ width: 190 }}
                  />
                  <div style={{ marginLeft: 7 }}>
                    <input
                      style={{ width: 180 }}
                      name="picture_name_6"
                      type="text"
                      className="ecas-input-field"
                      value={picture_name_6}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 d-flex align-items-baseline">
                <div className="flex-wrap picture-div d-flex align-items-center">
                  <p
                    style={{
                      fontSize: 17,
                      position: "relative",
                      top: -50,
                    }}
                  >
                    7)
                  </p>
                  <img
                    className="form-picture"
                    src={"./assets/images/ecas-form/duck.png"}
                    alt="scorpion"
                    style={{ width: 190 }}
                  />
                  <div style={{ marginLeft: 7 }}>
                    <input
                      style={{ width: 180 }}
                      name="picture_name_7"
                      type="text"
                      className="ecas-input-field"
                      value={picture_name_7}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 d-flex align-items-baseline">
                <div className="flex-wrap picture-div d-flex align-items-center">
                  <p
                    style={{
                      fontSize: 17,
                      position: "relative",
                      top: -50,
                    }}
                  >
                    8)
                  </p>
                  <img
                    className="form-picture"
                    src={"./assets/images/ecas-form/music-tool.png"}
                    alt="scorpion"
                    style={{ width: 190 }}
                  />
                  <div style={{ marginLeft: 7 }}>
                    <input
                      style={{ width: 210 }}
                      name="picture_name_8"
                      value={picture_name_8}
                      type="text"
                      className="ecas-input-field"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div className="col-lg-6">
            <span className="fs-19">Score (0-8) </span>
            <input
              type="number"
              value={written_picture_score}
              name="written_picture_score"
              readOnly
              className="ecas-input-field"
            />
          </div>
        </div>
      </div>
    );
  }
}
